module.exports = __webpack_public_path__ + "static/media/app_help.44cc5f89.svg";